'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge, LayoutStack } from 'design-system/client';
import { useTranslations, useLocale } from 'next-intl';
import analytics from 'product-analytics';
import { type RefObject, useCallback } from 'react';
import AttributionModal from '../AttributionModal';
import DonateButton from '../DonateButton';
import styles from './DonateAndShareSection.module.css';
import StickyBar from './StickyBar/StickyBar';
import ButtonLink from '@/components/ButtonLink';
import { Routes } from '@/helpers/utils';
function ClosedBadge() {
  const $ = _c(4);
  const t = useTranslations("nextjs.core");
  let t0;
  if ($[0] !== t) {
    t0 = t("state_labels.closed");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Badge kind="success" className={styles.closedBadge}>{t0}</Badge>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DonateAndShareSection(t0) {
  const $ = _c(31);
  const {
    fundraisingEventId,
    donationFormUrl,
    fundraisingEventName,
    title,
    stickyIntersectionSpyRef,
    isClosed: t1,
    slug
  } = t0;
  const isClosed = t1 === undefined ? false : t1;
  const locale = useLocale();
  const t = useTranslations("nextjs.core");
  let t2;
  if ($[0] !== fundraisingEventId || $[1] !== title) {
    t2 = () => {
      analytics.shareButtonClicked({
        id: fundraisingEventId,
        page_type: "fundraising_event",
        title,
        button_location: "fun_e_main"
      });
    };
    $[0] = fundraisingEventId;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const trackShareButtonClicked = t2;
  let t3;
  if ($[3] !== donationFormUrl || $[4] !== fundraisingEventId || $[5] !== fundraisingEventName || $[6] !== slug || $[7] !== stickyIntersectionSpyRef || $[8] !== title) {
    t3 = <StickyBar spyRef={stickyIntersectionSpyRef} donationFormUrl={donationFormUrl} fundraisingEventId={fundraisingEventId} slug={slug} title={title}>{fundraisingEventName}</StickyBar>;
    $[3] = donationFormUrl;
    $[4] = fundraisingEventId;
    $[5] = fundraisingEventName;
    $[6] = slug;
    $[7] = stickyIntersectionSpyRef;
    $[8] = title;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== locale || $[11] !== slug) {
    t4 = Routes.fundraisingEventsSharingOptions({
      locale,
      slug,
      utm_campaign: "user_share",
      utm_medium: "fepp_stats"
    });
    $[10] = locale;
    $[11] = slug;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t) {
    t5 = t("share_button");
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== trackShareButtonClicked) {
    t6 = <ButtonLink kind="secondary" fullWidth="mobile-only" onClick={trackShareButtonClicked} href={t4}>{t5}</ButtonLink>;
    $[15] = t4;
    $[16] = t5;
    $[17] = trackShareButtonClicked;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== donationFormUrl || $[20] !== fundraisingEventId || $[21] !== isClosed || $[22] !== stickyIntersectionSpyRef) {
    t7 = isClosed ? <ClosedBadge /> : <DonateButton id="main-donate-button" donationFormUrl={donationFormUrl} fundraisingEventId={fundraisingEventId} buttonLocation="FunE Main"><div ref={stickyIntersectionSpyRef} style={{
        width: "1",
        height: 1
      }} /></DonateButton>;
    $[19] = donationFormUrl;
    $[20] = fundraisingEventId;
    $[21] = isClosed;
    $[22] = stickyIntersectionSpyRef;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <AttributionModal id="donate-and-share-section-attribution-modal" />;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t6 || $[26] !== t7) {
    t9 = <LayoutStack space="300" className={styles.container}>{t6}{t7}{t8}</LayoutStack>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t3 || $[29] !== t9) {
    t10 = <section>{t3}{t9}</section>;
    $[28] = t3;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
}
export default DonateAndShareSection;